// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__b9ugM","approved":"Status_approved__1bamq","rejected":"Status_rejected__1eZqg","expired":"Status_expired__3wj7J","label":"Status_label__2d6St"};